import React, { useEffect, useState } from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";
import { toast } from "react-toastify";
const TableData = (props) => {
    // const [rowsPerPage, setRowsPerPage] = useState(10);
    // const [page, setPage] = useState(0);
    const [displayData, setDisplayData] = useState([]);
    // const [selectedUserId, setSelectedUserId] = useState(null);

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };
    const handleUserClick = (userId, appCount) => {
        if(appCount){
            props.setSelectedUserId(userId);
            props.getAppointmentDetail(userId)
        } else {
            toast.warn("No appointments scheduled for the selected date range", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    useEffect(() => {
        setDisplayData(props.reportData);
    }, [props]);

    return (
        <>
            <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM">S.No.</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM">Name</span>
                                </TableCell>
                                {props.user === 'Doctor' &&
                                    <>
                                        <TableCell className="tableHead">
                                            <span className="elslistTxtM ">Department</span>
                                        </TableCell>
                                        <TableCell className="tableHead">
                                            <span className="elslistTxtM ">Specialization </span>
                                        </TableCell>
                                    </>
                                }
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">Free</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">Paid</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">Total Amount (Cents)</span>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayData.map((each, index) => (
                                <TableRow>
                                    <TableCell className="capitalTxt">{index+1}</TableCell>
                                    <TableCell className="capitalTxt">
                                        <span 
                                            className="clickable" 
                                            onClick={() => handleUserClick(each.userId, each.docRes.length)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {each.firstName}
                                        </span>
                                    </TableCell>
                                    {props.user === 'Doctor' &&
                                        <>
                                            <TableCell className="capitalTxt">{each.department}</TableCell>
                                            <TableCell className="capitalTxt">{each.speciality}</TableCell>
                                        </>
                                    }
                                    {each.docRes.length > 0 ? <TableCell className="capitalTxt">{each.docRes[0].freeCount}</TableCell> : <TableCell className="capitalTxt">0</TableCell>}
                                    {each.docRes.length > 0 ? <TableCell className="capitalTxt">{each.docRes[0].paidCount}</TableCell> : <TableCell className="capitalTxt">0</TableCell>}
                                    {each.docRes.length > 0 ? (
                                        <TableCell className="capitalTxt">{each.docRes[0].totalAmountInCents === "null" ? 0 : each.docRes[0].totalAmountInCents  }</TableCell>
                                    ) : (
                                        <TableCell className="capitalTxt">0</TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <div className="flexCol justifyEnd">
                <TablePagination
                    component="div"
                    count={props.count}
                    page={props.page}
                    onPageChange={props.handleChangePage}
                    rowsPerPage={props.rowsPerPage}
                    onRowsPerPageChange={props.handleChangeRowsPerPage}
                />
            </div>
        </>
    );
};
export default TableData;
